<template>
  <span class="user-icon" :class="{ admin }">
    <font-awesome-icon v-if="admin" icon="crown" fixed-width></font-awesome-icon>
    <font-awesome-icon v-else icon="user" fixed-width></font-awesome-icon>
    <md-tooltip v-if="admin" md-direction="right">Admin</md-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    admin: Boolean,
  },
}
</script>

<style lang="scss" scoped>
// TODO テーマのPrimaryとAccent色の取り方が分からない、、、
.user-icon {
  // color: #448aff;
  color: rgba(0, 0, 0, 0.54);
  &.admin {
    color: #ff5252;
  }
}
</style>
